import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(marketing)/_components/offer-content.tsx");
